import clsx from "clsx";
import { HOME_SKELETON_CLASS } from "./homeSurfaces";

/** Pulse bar for home / review loading skeletons — uses shared `SURFACE_SKELETON` token. */
export function HomeSkeletonBar({ className }: { className?: string }) {
  return (
    <div className={clsx("rounded-md", HOME_SKELETON_CLASS, className)} aria-hidden />
  );
}
